var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVindi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4513.88 4554.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n   \n    .fil1 {fill:#001A9C}\n    .fil0 {fill:#01A3FC}\n\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1411.64 4344.13c-33.13,-101.19 -26.15,60.82 -65.48,100.73 -56.09,56.93 -27.74,63.81 54.4,80.36 182.55,36.78 1250.43,49.19 1417.65,-22.65 118.05,-50.72 205.71,-278.45 257.65,-392.53 135.97,-298.64 218.69,-635.19 330.73,-945.78 137.16,-374.75 291.55,-743.61 437.95,-1114.87 213.2,-544.35 444.97,-1102.16 643.59,-1650.26 107.91,-384.26 -138.87,-402.18 -453.07,-398.82 -207.34,2.21 -434.53,5.02 -640.71,11.98 -351.88,11.88 -367.68,121.75 -489.21,435.18l-18.53 47.79c-214.26,558.79 -395.58,1128.77 -635.36,1677.65 -39.78,90.45 -74.75,147.9 -110.95,243.54 -243.09,642.5 -482.43,1286.37 -728.66,1927.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1638.78 3232.31c73.76,-285.56 279.78,-927.99 184,-1194.43 -66.86,-186.03 -146.66,-353.82 -212.18,-547.06 -74.42,-219.53 -147.87,-408.91 -351.28,-540.04 -29.43,-13.17 -47.58,-16.58 -78.61,-22.84 -188.51,-19.87 -935.17,-45.85 -1073.18,37.45 -184.14,182.08 -95.78,407.92 -0.77,615.12 76.73,167.33 146.4,303.4 217.77,477.84 321.23,783.87 671.48,1563.22 953.5,2361.79 23.09,65.39 17.78,78.62 66.73,30.75 17.69,-17.29 61.63,-177.45 64.33,-194.11 58.95,-363.51 145.2,-670.16 229.69,-1024.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVindi);
export default __webpack_public_path__ + "static/media/Vindi.69efb19ce7df164987a2493084b0b466.svg";
export { ForwardRef as ReactComponent };